<template>
    <div class="jd-order-list" v-if="orderList">
        <div v-if="!orderList.length" class="k-nodata">
            <div v-if="place==='user'">
                <br/><br/><br/>
                <k-icon name="shopping-cart-o" color="#eee" size="80"></k-icon><br/><br/>
                暂无数据，赶快去发布个鉴定吧！<br/><br/><br/>
                <k-button type="default" size="small" to="/publish">发布鉴定</k-button>
            </div>
            <span v-else>暂无数据！</span>
        </div>
        <div v-for="(item,index) in orderList" :key="item.id" >
            <k-panel :title="`订单号：${item.orderno}`" :status="formatStatus(item.status)">
                <router-link :to="detailUrl(item.id)">
                    <k-view-two
                        :img="(item.pictures || '')|getPic|resize(100,100)"
                        :title="getTitle(item)"
                        :price="(item.money || 0)|fen2yuan"
                    />
                </router-link>
                <div slot="footer" class="ta-right k-btns">
                    <order-btns :order-id="item.id" :status="item.status" :place="place" />
                </div>
            </k-panel>
            <k-hr />
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import OrderBtns from "../components/order-btns"
    export default {
        name: "order-list",
        props: ["status","place","list"],
        components : {
          OrderBtns
        },
        computed : {
            ...mapGetters("jianding", ["getOrders","CONST"]),
            orderList(){
                return this.getOrders(0)
            },

        },
        filters: {
            formatStatus(value){
                return this.CONST.ORDER_STATUS_TEXT[value]
            }
        },
        methods : {
            ...mapActions("jianding", ["loadOrders"]),
            detailUrl(id){
                if(this.place === 'appraiser'){
                    return `/appraiser/order/detail?orderId=${id}`
                }
                return `/my/order/detail?orderId=${id}`
            },
            formatStatus(value){
                return this.CONST.ORDER_STATUS_TEXT[value]
            },
            getTitle(val){
                let { CONST} = this;
                if(!val || !val.status) return '';
                if(val.status === CONST.ORDER_STATUS_FINISHED || status === CONST.ORDER_STATUS_EVALUATE ){
                    return val.definition || ''
                }
                return (val.aname || "") + " " + CONST.SERVICE_TYPE[val.type || "default"]
            }
        },
        watch : {
            getOrders(nv){
                console.log(nv)
            }
        }
    }
</script>